import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX, faCalendar, faClock, faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import "./componentsCss/RescheduleModal.css";

const RescheduleModal = ({ schedule, patient, onClose, onConfirm }) => {
  const initialProcedures = Array.isArray(schedule?.procedures)
    ? schedule.procedures
        .filter((p) => !p.cancel && !p.confirmed)
        .map((proc) => ({
          ...proc,
          date: schedule.date || "",
          time: proc.time_booked || "",
        }))
    : [];

  const [updatedProcedures, setUpdatedProcedures] = useState(initialProcedures);

  const handleProcedureChange = (index, field, value) => {
    const updated = [...updatedProcedures];
    updated[index][field] = value;
    setUpdatedProcedures(updated);
  };

  const handleConfirm = () => {
    const payload = {
      items: updatedProcedures.map((p) => ({
        scheduling_id: p.scheduling_id,
        procedure_id: p.procedure_id,
        date_scheduling: p.date,
        time_booked: p.time,
      })),
    };
    console.log("Procedimentos selecionados:", payload);
    if (onConfirm) onConfirm(payload);
    onClose();
  };

  useEffect(() => {
    console.log("Procedimentos selecionados:", updatedProcedures);
  }, [updatedProcedures]);

  return (
    <div className="modal-overlay">
      <div className="reschedule-modal">
        <div className="modal-header">
          <h2>Reagendar Procedimentos</h2>
          <button className="close-button" onClick={onClose}>
          <FontAwesomeIcon icon={faX} />
          </button>
        </div>

        <div className="modal-body">
          <p>
            <strong>Paciente:</strong> {patient?.name}
          </p>
          <p>
            <strong>Médico:</strong>{" "}
            {schedule?.professional_name || "Não informado"}
          </p>

          <div className="procedure-list">
            {updatedProcedures.length === 0 ? (
              <p>Nenhum procedimento agendado para reagendamento.</p>
            ) : (
              updatedProcedures.map((proc, index) => (
                <div key={proc.id} className="procedure-item">
                  <h4>{proc.procedure_name}</h4>

                  <div className="form-group">
                    <label>
                    <FontAwesomeIcon icon={faCalendar} /> Nova Data:
                    </label>
                    <input
                      type="date"
                      value={proc.date}
                      onChange={(e) =>
                        handleProcedureChange(index, "date", e.target.value)
                      }
                    />
                  </div>

                  <div className="form-group">
                    <label>
                    <FontAwesomeIcon icon={faClock} /> Novo Horário:
                    </label>
                    <input
                      type="time"
                      value={proc.time}
                      onChange={(e) =>
                        handleProcedureChange(index, "time", e.target.value)
                      }
                    />
                  </div>
                </div>
              ))
            )}
          </div>
        </div>

        <div className="modal-footer">
          <button className="cancel-button" onClick={onClose}>
            Cancelar
          </button>
          <button
            className="confirm-button"
            onClick={handleConfirm}
            disabled={updatedProcedures.length === 0}>
            <FontAwesomeIcon icon={faCheckCircle} /> Confirmar Reagendamento
          </button>
        </div>
      </div>
    </div>
  );
};

export default RescheduleModal;
